module.exports = __webpack_public_path__ + "img/1491254282.292ff798.jpg";